import { CustomEventEmitter } from '../../core/CustomEventEmitter';
import { TaskError } from '../../errors/TaskError';
import { ConnectionAvailableEvent } from '../../events/ConnectionAvailableEvent';
import { ConnectionBusyEvent } from '../../events/ConnectionBusyEvent';
import { ConnectionProgressEvent } from '../../events/ConnectionProgressEvent';
export class Connection extends CustomEventEmitter {
    constructor(name) {
        super();
        this.task = null;
        this.name = name;
    }
    isBusy() {
        return Boolean(this.task);
    }
    isAvailable() {
        return !Boolean(this.task);
    }
    wakeUp() {
        this.available();
        return this;
    }
    available() {
        this.dispatch(new ConnectionAvailableEvent(this.name));
        return this;
    }
    ping() {
        if (this.isAvailable()) {
            this.available();
        }
        else {
            this.busy();
        }
        return this;
    }
    busy(task) {
        this.dispatch(new ConnectionBusyEvent(this.name, task));
        return this;
    }
    progress(loaded, part) {
        this.dispatch(new ConnectionProgressEvent(this.name));
    }
    startTask(task) {
        this.task = task;
        return this;
    }
    getTask() {
        return this.task;
    }
    endTask() {
        this.task = null;
        return this;
    }
    execute(task) {
        this.startTask(task);
        return new Promise(resolve => {
            try {
                setTimeout(async () => {
                    const processedTask = await task.execute();
                    resolve(processedTask);
                    this.endTask();
                }, task.delay);
            }
            catch (error) {
                task.error = new TaskError(task, error);
                resolve(task);
                this.endTask();
            }
        });
    }
    reset() {
    }
}
